import { createFileRoute } from "@tanstack/react-router";
import CompetitorCompare from "@/pages/CompetitorCompare";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findCompetitor } from "@/lib/competitors";

export const Route = createFileRoute("/vs/$competitor")({
  head: ({ params }) => {
    const c = findCompetitor(params.competitor);
    const name = c?.name ?? readable(params.competitor);
    return {
      meta: [
        // Kept out of search: operator-brand pages trip gambling-promotion filters.
        { name: "robots", content: "noindex, follow" },
        ...socialMeta({
        seo: { topics: ["footballPredictions", "home"] },
        title: `Statlign vs ${name} | Football Prediction Site Comparison`,
        description: `How Statlign compares with ${name} on transparency, market coverage, model reasoning and pricing.`,
        ogType: "article",
      }),
      ],
    };
  },
  component: () => (
    <MainLayout>
      <CompetitorCompare />
    </MainLayout>
  ),
});
